class BannerSlider extends HTMLElement {
  constructor() {
    super();
    const initMainBannerSection = (panel) => {
  const container = document.createElement("div");
  container.style.height = "100vh";
  container.style.position = "relative";
  // container.style.top = "0";

  panel.parentNode.insertBefore(container, panel);
  container.appendChild(panel);

  return gsap.timeline({
    scrollTrigger: {
      trigger: panel,
      start: "top top",
      scrub: 1,
    },
  });
    };

    const bannerSelector = document.querySelector(".section-banner-slider");

    if (bannerSelector) {
      ScrollTrigger.matchMedia({
        // ✅ Desktop only
        "(min-width: 1024px)": () => {
          const tl = initMainBannerSection(bannerSelector);
          return () => {
            // cleanup when leaving desktop
            tl.kill();
            ScrollTrigger.refresh();

            // unwrap panel from sticky container
            const wrapper = bannerSelector.parentNode;
            if (wrapper && wrapper.style.position === "sticky") {
              wrapper.replaceWith(bannerSelector);
            }
          };
        },

        // Optional: for smaller devices
        "(max-width: 1023px)": () => {
          // unwrap panel if sticky already applied
          const wrapper = bannerSelector.parentNode;
          if (wrapper && wrapper.style.position === "sticky") {
            wrapper.replaceWith(bannerSelector);
          }
        },
      });
    }

  }

  connectedCallback() {
    const root = this;
    const swiperEl = this.querySelector('[data-banner-swiper]');
    if (!swiperEl) return;
    const fadeSelector = '[data-fade-up-heading], [data-fade-up-text], [data-fade-up-btn]';
    const allFadeEls = Array.from(this.querySelectorAll(fadeSelector));
    if (allFadeEls.length) gsap.killTweensOf(allFadeEls);
    allFadeEls.forEach((el) => {
      el.dataset._origTransition = el.style.transition || '';
      el.style.transition = 'none';
    });
    gsap.set(allFadeEls, { y: 25, opacity: 0 });
    const swiper = new Swiper(swiperEl, {
      loop: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
        renderBullet: function (index, className) {
          return `
            <span class="${className}">
              <svg viewBox="0 0 20 20" width="20" height="20">
                <circle class="dot" cx="10" cy="10" r="4.75"></circle>
                <circle class="progress-ring" cx="10" cy="10" r="9"></circle>
              </svg>
            </span>
          `;
        },
      },
    });
    const restoreTransitions = (els) => {
      els.forEach((el) => {
        if (el && el.dataset._origTransition !== undefined) {
          el.style.transition = el.dataset._origTransition;
          delete el.dataset._origTransition;
        }
      });
    };
    const hideElements = (els) => {
      if (!els || !els.length) return;
      gsap.killTweensOf(els);
      els.forEach((el) => {
        if (el.dataset._origTransition === undefined) el.dataset._origTransition = el.style.transition || '';
        el.style.transition = 'none';
      });
      gsap.set(els, { y: 25, opacity: 0 });
    };
    const runSlideAnimation = (slide) => {
      if (!slide) return;
      const heading = slide.querySelector('[data-fade-up-heading]');
      const texts = Array.from(slide.querySelectorAll('[data-fade-up-text]'));
      const buttons = Array.from(slide.querySelectorAll('[data-fade-up-btn]'));
      const elems = [];
      if (heading) elems.push(heading);
      elems.push(...texts);
      elems.push(...buttons);
      if (elems.length) gsap.killTweensOf(elems);
      elems.forEach((el) => {
        if (el.dataset._origTransition === undefined) el.dataset._origTransition = el.style.transition || '';
        el.style.transition = 'none';
      });
      gsap.set(elems, { y: 25, opacity: 0 });
      const tl = gsap.timeline({ onComplete: () => restoreTransitions(elems) });
      if (heading) {
        tl.to(heading, { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out' });
      }
      if (texts.length) {
        texts.forEach((text, i) => {
          tl.to(text, { y: 0, opacity: 1, duration: 0.4, ease: 'power3.out' }, '+=0.1');
        });
      }
      if (buttons.length) {
        buttons.forEach((btn, i) => {
          tl.to(btn, { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' }, '+=0.15');
        });
      }
    };
    requestAnimationFrame(() => {
      const initialActiveRing = root.querySelector(
        '[data-banner-swiper] .swiper-pagination-bullet-active .progress-ring'
      );
      if (initialActiveRing) {
        initialActiveRing.style.transition = 'none';
        initialActiveRing.style.strokeDashoffset = 56.55;
        void initialActiveRing.offsetWidth;
        initialActiveRing.style.transition =
          'stroke-dashoffset ' + swiper.params.autoplay.delay / 1000 + 's linear';
        initialActiveRing.style.strokeDashoffset = 0;
      }
    });
    swiper.on('slideChangeTransitionStart', () => {
      const rings = root.querySelectorAll(
        '[data-banner-swiper] .swiper-pagination-bullet .progress-ring'
      );
      rings.forEach((ring) => {
        ring.style.transition = 'none';
        ring.style.strokeDashoffset = 56.55;
      });
      const nowAll = Array.from(root.querySelectorAll(fadeSelector));
      hideElements(nowAll);
    });
    swiper.on('slideChangeTransitionEnd', () => {
      const activeRing = root.querySelector(
        '[data-banner-swiper] .swiper-pagination-bullet-active .progress-ring'
      );
      if (activeRing) {
        activeRing.style.transition =
          'stroke-dashoffset ' + swiper.params.autoplay.delay / 1000 + 's linear';
        activeRing.style.strokeDashoffset = 0;
      }

      const activeSlide = swiper.slides[swiper.activeIndex];
      runSlideAnimation(activeSlide);
    });
    requestAnimationFrame(() => {
      const firstSlide = swiper.slides[swiper.activeIndex];
      runSlideAnimation(firstSlide);
    });
  }
}

customElements.define('banner-slider', BannerSlider);